import { useCallback } from 'react';

import { convertToUsdString } from 'src/app/shared/utils/currency';

import { useMembershipModalState } from '../../modalContext';

type Result = {
	toAmountUsd: (amount: number) => string;
};

export function useAmountConverter(): Result {
	const [{ currencyExchangeRate }] = useMembershipModalState();

	const toAmountUsd = useCallback(
		(amount: number) => convertToUsdString(amount, currencyExchangeRate),
		[currencyExchangeRate],
	);

	return { toAmountUsd };
}
